import { render, staticRenderFns } from "./WholeSaleDay.vue?vue&type=template&id=6ef20132&scoped=true&"
import script from "./WholeSaleDay.vue?vue&type=script&lang=js&"
export * from "./WholeSaleDay.vue?vue&type=script&lang=js&"
import style0 from "./WholeSaleDay.vue?vue&type=style&index=0&id=6ef20132&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ef20132",
  null
  
)

export default component.exports